import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[noDblClick]'
})
export class NoDbClickDirective {

  @HostListener('click', ['$event'])
  clickEvent(event: any) {
    const target = (event && event.target) || (event && event.srcElement);
    const contains = ['a',  'button', 'span'];
    let clickedElement: any;

    if (target && contains.includes(target.tagName.toLowerCase())) {
      clickedElement = target;
    } else {
      clickedElement = this.findParentTag(target, contains);
    }

    clickedElement.style.pointerEvents = 'none';

    setTimeout(() => {
      clickedElement.style.pointerEvents = 'auto';
    }, 1000);
  }

  findParentTag(el: any, tag: any) {
    while (el.parentNode) {
      el = el.parentNode;
      if (el.tagName === tag) {
        return el;
      }
    }
    return null;
  }
}
